import React from 'react';

import CDNImage from "../cdn-image";

import '../../../styles/common/promos/pdia-banner.scss';

const PDIABanner = (props) => (
	<>
		<div
			role="complementary"
			aria-label="Promotional Banner"
			className={`sitewide-banner pdia-banner`}
		>
			<a href="https://pdimagearchive.org?utm_source=PDR&utm_medium=topbanner&utm_campaign=PDRtoPDIA">
				<div className="image-underlay">
					<CDNImage
						imagePath="/banners/pdia-grid-banner-1600.jpg"
						width="1600"
						height="524"
						alt="Grid of images from the PDIA"
					/>
				</div>
				<div className="label">
					<span className="headline">
						Visit Our New Project, The Public Domain Image Archive
					</span>
					<span className="tagline">
						A Curated Collection of 10,000+ Images, Free for All to Explore, Download, and Reuse
					</span>
				</div>
			</a>
		</div>
	</>
);

export default PDIABanner;